// extracted by mini-css-extract-plugin
export default {"badgeContainer":"badge_badgeContainer__E-un8"};